function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "756A3D37-CA3D-4B4C-9CC8-B099741DC6E6");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "v2---search-results",
  transform: "translate(-87.000000, -202.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  id: "toolabar",
  transform: "translate(0.000000, 190.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "btn-config",
  transform: "translate(84.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/columns"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,18 L14,18 L14,5 L9,5 L9,18 Z M3,18 L8,18 L8,5 L3,5 L3,18 Z M15,5 L15,18 L20,18 L20,5 L15,5 Z",
  id: "Shape"
}))))));

var SvgColumns = function SvgColumns(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColumns, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/columns.6063d4c2.svg";
export { ForwardRef as ReactComponent };